module.exports = __webpack_public_path__ + "static/img/report_code.49fbd557.png";